function nextDayDate(date) {
  const tomorrow = date ? new Date(date) : new Date()
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0,0,0,0)
    return new Date(`${tomorrow.getFullYear()}/${tomorrow.getMonth() + 1}/${tomorrow.getDate()}`);
}

export default nextDayDate;